import { MetricCell } from "components/designV2/metricCell/metricCell";
import { Text } from "components/designV2/text/text";
import { ColorV2 } from "config/colors";
import { AbsenceType, AGIAbsence } from "model/Salary";
import { formatDuration } from "utils/utils";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { AbsenceRowGrid, SectionContainer } from "./absenceDetailRow.styled";

interface AbsenceDetailRowProps {
  absences: AGIAbsence[];
}

export const AbsenceDetailRow: React.FC<AbsenceDetailRowProps> = (props) => {
  const { t } = useTranslation();

  const formatDate = useCallback((dateString: string): string => {
    try {
      return new Date(dateString).toISOString().split("T")[0];
    } catch (error) {
      console.error("Invalid date format:", dateString, error);
      return "Invalid date";
    }
  }, []);

  const translateAbsenceType = useCallback(
    (type: number): string => {
      switch (type) {
        case AbsenceType.PARENTAL_LEAVE:
          return t("Salary.parentalLeave");
        case AbsenceType.VAB:
          return t("Salary.VAB");
        default:
          return "-";
      }
    },
    [t],
  );

  const renderAbsenceRow = useCallback(
    (absence: AGIAbsence, index: number, totalLength: number) => {
      const isLastRow = index === totalLength - 1;
      return (
        <AbsenceRowGrid
          $isLastRow={isLastRow}
          key={`absence-${absence.date}-${index}`}
        >
          <MetricCell
            value={formatDate(absence.date)}
            label={t("Salary.Date")}
          />
          <MetricCell
            value={translateAbsenceType(absence.type)}
            label={t("Salary.Type")}
          />
          <MetricCell
            value={formatDuration(absence.hours.toString())}
            label={t("Salary.Hours")}
          />
        </AbsenceRowGrid>
      );
    },
    [t, formatDate, translateAbsenceType],
  );

  if (props.absences.length === 0) {
    return null;
  }

  return (
    <SectionContainer>
      <Text typography="h5" color={ColorV2.Blue1}>
        {t("Salary.Absence")}
      </Text>
      {props.absences.map((absence, index) =>
        renderAbsenceRow(absence, index, props.absences.length),
      )}
    </SectionContainer>
  );
};
